import { render, staticRenderFns } from "./DetailedSlotPatientChosen.vue?vue&type=template&id=2e913357&"
import script from "./DetailedSlotPatientChosen.vue?vue&type=script&lang=ts&"
export * from "./DetailedSlotPatientChosen.vue?vue&type=script&lang=ts&"
import style0 from "./DetailedSlotPatientChosen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports